<app-leave-page-confirmation #exitConfirmOverlay></app-leave-page-confirmation>
<app-pop-up-notification
    #conflictNotification
    [message]="'custom-group.create.error.max-groups'"
    [closeButton]="'dlg.signin.close'"
    [hideTimeout]="null"
></app-pop-up-notification>

<div
    class="page-flex container-width"
    style="margin: 0 auto"
    [hidden]="previewChannels.length > 0"
>
    <!-- Channel name Input -->
    <div class="custom-group-header">
        <div class="custom-title">
            <div style="width: 100%">
                <div style="position: relative">
                    <input
                        data-cy="custom-channel-group-title"
                        id="input-bar"
                        type="text"
                        class="input-name"
                        [(ngModel)]="newGroupName"
                        [placeholder]="
                            'forms.channels.custom-group.title.placeholder'
                                | translate
                        "
                        (input)="checkName($event)"
                        (click)="editTitle(); $event.stopPropagation()"
                        maxlength="32"
                        autocomplete="off"
                        (focus)="displaySuggestions = true"
                    />
                    <app-used-titles-suggestions
                        *ngIf="displaySuggestions"
                        [titleList]="getTitleList()"
                        (onHideSuggestions)="displaySuggestions = false"
                        (onTitleSelected)="
                            newGroupName = $event; emitName($event)
                        "
                    ></app-used-titles-suggestions>
                </div>

                <app-validation-error-label
                    *ngIf="
                        (titleIsRepeated() ||
                            newGroupName?.trim().length == 0) &&
                        !isSubmiting
                    "
                    [message]="titleError"
                ></app-validation-error-label>
            </div>
        </div>

        <div class="buttons">
            <div
                data-cy="custom-channel-group-cancel-button"
                class="button"
                (click)="onDiscard()"
            >
                {{ "forms.channels.custom-group.buttons.cancel" | translate }}
            </div>
            <button
                data-cy="custom-channel-group-save-button"
                class="button Submit"
                [disabled]="checkRequiredConditions()"
                (click)="onSubmit()"
            >
                {{ "forms.channels.custom-group.buttons.save" | translate }}
            </button>
        </div>
    </div>

    <div
        class="search-container"
        [ngStyle]="{ 'margin-bottom': selectingChannels ? '200px' : null }"
    >
        <div class="right-container">
            <div
                class="custom-page-textarea-container custom-page-textarea-container-margin"
            >
                <div class="custom-page-textarea-label">
                    {{
                        "forms.channels.custom-group.description.title"
                            | translate
                    }}
                </div>
                <app-textarea
                    style="height: 100%"
                    data-cy="custom-channel-group-description"
                    [customClass]="'custom-page-textarea'"
                    [placeholder]="
                        'forms.channels.custom-group.description.placeholder'
                    "
                    [value]="newGroupDescription"
                    (onValueChange)="editDescription($event)"
                    [maxlength]="255"
                />
            </div>

            <!-- Share Settings -->
            <app-page-share-settings
                [ngClass]="['share-settings-wrapper', responsive.screenSize]"
                [isPublic]="isPublicGroup"
                [usersAccess]="usersAccess"
                [isCreating]="editData ? false : true"
                (onAccessChanged)="handleAccessChanged($event)"
                (onUserPermissionChanged)="handleUserAccessChanged($event)"
            ></app-page-share-settings>

            <app-search-channel-group
                (onChannelsSelected)="onSelectedChannelsChanged($event)"
                [editChannels]="editChannels"
                (onShowingTable)="handleTableDisplay($event)"
                [page]="pageTitle"
                #searchChannelComponent
                (onShowPreview)="onShowPreviewChannelList()"
                (onLoadingComplete)="onLoadingCompleted()"
            >
            </app-search-channel-group>
        </div>
        <div class="left-container" *ngIf="!showPreview()">
            <div
                data-cy="custom-channel-group-channels-title"
                class="left-title"
            >
                {{ "forms.channels.custom-group.channel.label" | translate }}
            </div>
            <p data-cy="custom-channel-group-selected-channels-label">
                {{
                    "custom-group.labels.add-channel-prompt"
                        | translate: { max: MAX_CHANNELS }
                }}
            </p>
            <div
                *ngIf="channelsSelected.length > 0 && !showPreview()"
                class="left-channels"
            >
                <div
                    data-cy="custom-channel-group-channel-badge"
                    *ngFor="let channel of channelsSelected"
                    class="channel-name"
                >
                    {{ channel.name }}
                    <mat-icon
                        data-cy="custom-channel-group-channel-badge-x-icon"
                        class="close-icon"
                        (click)="removeChannel(channel)"
                        >clear</mat-icon
                    >
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="previewChannels.length > 0 && showPreview()" class="left-container">
    <button
        (click)="onPreviewBack()"
        [ngClass]="[
            'close-button',
            responsive.deviceAndOrientation,
            responsive.screenSize,
        ]"
    >
        {{ "forms.channels.custom-group.preview.button.close" | translate }}
    </button>
    <div class="left-title">
        {{ "forms.channels.custom-group.channel.label" | translate }}
    </div>
    <div class="left-channels">
        <div *ngFor="let channel of channelsSelected" class="channel-name">
            {{ channel.name }}
            <mat-icon class="close-icon" (click)="removeChannel(channel)"
                >clear</mat-icon
            >
        </div>
    </div>
    <div style="height: 150px"></div>
</div>

<div class="loading-spinner-container" *ngIf="!hasFinishedLoading()">
    {{ "general.notification.retreiving-data" | translate }}
    <app-loading-spinner
        style="height: 200px; width: 200px"
    ></app-loading-spinner>
</div>
